export const USER_INFO = 'user-info'
export const TOKEN = 'token'
export const REFRESH_TOKEN = 'refresh-token'
// Slug of the last-visited RMN white-label portal; read on 401 logout so the
// session-expiry redirect returns to the branded login instead of /login.
export const RMN_SLUG = 'rmn_slug'
